import React from 'react'
import AnchorLink from 'react-anchor-link-smooth-scroll'
import { Header } from 'Theme'
import { Container, Button } from 'Common'
import dev from 'Static/illustrations/dev.svg'
import { Wrapper, IntroWrapper, Details, Thumbnail } from './styles'

export const Intro = () => (
	<Wrapper>
		<Header />
		<IntroWrapper as={Container}>
			<Details>
				<h1>Hey There!</h1>
				<h4> I’m a Frontend Developer!</h4>
				<h4>My work is to bring good designs to life.</h4>
				<p>If you have a project or creative need that I can help with,</p>
				{/* <p>I have made few things check it out.</p> */}
				<Button as={AnchorLink} href="#contact">
					Email me
				</Button>
			</Details>
			<Thumbnail>
				<img src={dev} alt="I’m a Frontend Developer!" />
			</Thumbnail>
		</IntroWrapper>
	</Wrapper>
)
